import { combineReducers } from "redux";
import uiReducer from "./dux/ui/reducer";
import settingsReducer from "./dux/settings/reducer";
import { searchReducer } from "./components/SearchBar/reducer";

const selectedReducer = (
  state = { name: "General", smallName: "general" },
  { type, payload }
) => {
  switch (type) {
    case "UPDATE_SELECTED":
      return payload;
    default:
      return state;
  }
};

const staticReducer = (state = {}, { type, payload }) => {
  return state;
};

export default combineReducers({
  config: (state = {}) => state,
  residents: (state = {}) => state,
  static: staticReducer,
  filters: searchReducer,
  selected: selectedReducer,
  settings: settingsReducer,
  ui: uiReducer,
});
